export default {
  TOP: 'top',
  BOTTOM: 'bottom',
  NONE: 'none',
};
